import React from 'react'

const GameGlassTextLogo = () => {
  return (
    <svg
      viewBox="0 0 445.55099 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 49.423,47.8638 65.97,0 h 8.095 L 90.541,47.8638 89.831,49 H 85.925 L 81.593,35.9333 H 58.371 L 54.039,49 H 50.205 Z M 59.934,31.6725 H 80.102 L 70.941,4.3319 h -1.847 z"
        fill="#ffffff"
        id="path4"
      />
      <path
        d="M 104.896,49 V 0 H 111.5 L 128.686,36.3594 145.8,0 h 6.604 v 49 h -4.758 V 6.3203 l -16.617,35.3652 h -4.758 L 109.654,6.3203 V 49 Z"
        fill="#ffffff"
        id="path6"
      />
      <path
        d="M 171.83,49 V 0 h 31.53 v 4.3319 h -26.772 v 16.6884 h 24.642 v 4.2609 H 176.588 V 44.6681 H 203.36 V 49 Z"
        fill="#ffffff"
        id="path8"
      />
      <path
        d="M 273.658,49 V 0 h 4.758 v 44.6681 h 24.642 V 49 Z"
        fill="#ffffff"
        id="path10"
      />
      <path
        d="M 312.593,47.8638 329.14,0 h 8.095 L 353.711,47.8638 353,49 h -3.905 L 344.763,35.9333 H 321.541 L 317.209,49 h -3.835 z m 10.51,-16.1913 h 20.168 l -9.16,-27.3406 h -1.847 z"
        fill="#ffffff"
        id="path12"
      />
      <path
        d="m 365.935,46.8696 v -2.2015 h 21.873 c 3.692,0 5.539,-1.8464 5.539,-5.5391 v -5.9652 c 0,-3.0773 -1.373,-4.9 -4.119,-5.4681 L 373.605,24.5 c -5.113,-0.9942 -7.67,-4.4029 -7.67,-10.2261 V 10.5812 C 365.935,3.5271 369.462,0 376.516,0 h 17.47 l 2.698,2.1304 v 2.2015 h -20.381 c -3.74,0 -5.61,1.8464 -5.61,5.5391 v 4.9 c 0,3.1247 1.373,4.971 4.119,5.5391 l 15.694,3.0537 c 5.066,1.0415 7.599,4.4502 7.599,10.2261 v 4.8289 C 398.105,45.4729 394.578,49 387.523,49 h -18.818 z"
        fill="#ffffff"
        id="path14"
      />
      <path
        d="m 413.382,46.8696 v -2.2015 h 21.872 c 3.693,0 5.539,-1.8464 5.539,-5.5391 v -5.9652 c 0,-3.0773 -1.373,-4.9 -4.119,-5.4681 L 421.051,24.5 c -5.113,-0.9942 -7.669,-4.4029 -7.669,-10.2261 V 10.5812 C 413.382,3.5271 416.909,0 423.963,0 h 17.469 l 2.699,2.1304 V 4.3319 H 423.75 c -3.74,0 -5.61,1.8464 -5.61,5.5391 v 4.9 c 0,3.1247 1.372,4.971 4.118,5.5391 l 15.695,3.0537 c 5.065,1.0415 7.598,4.4502 7.598,10.2261 v 4.8289 C 445.551,45.4729 442.024,49 434.97,49 h -18.819 z"
        fill="#ffffff"
        id="path16"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M 0,10.5812 V 38.4188 C 0,45.4729 3.527,49 10.581,49 H 36.43 V 22.5188 l -4.758,2.7624 V 44.6681 H 10.368 c -3.74,0 -5.61,-1.8464 -5.61,-5.5391 V 9.871 c 0,-3.6927 1.87,-5.5391 5.61,-5.5391 H 35.01 V 2.1304 L 32.311,0 H 10.581 C 3.527,0 0,3.5271 0,10.5812 Z"
        fill="#ffffff"
        id="path18"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m 219.121,10.5812 v 27.8376 c 0,7.0541 3.527,10.5812 10.581,10.5812 h 25.849 V 22.5188 l -4.758,2.7624 v 19.3869 h -21.304 c -3.74,0 -5.61,-1.8464 -5.61,-5.5391 V 9.871 c 0,-3.6927 1.87,-5.5391 5.61,-5.5391 h 24.642 V 2.1304 L 251.432,0 h -21.73 c -7.054,0 -10.581,3.5271 -10.581,10.5812 z"
        fill="#ffffff"
        id="path20"
      />
      <defs id="defs36">
        <radialGradient
          id="paint0_radial_211_370"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0,96.2825,-165.093,0,63.9545,15.0431)"
        >
          <stop stopColor="#3CEC83" id="stop22" />
          <stop offset="0.29" stopColor="#5DD28C" id="stop24" />
          <stop offset="0.65" stopColor="#2D9972" id="stop26" />
          <stop offset="1" stopColor="#1D845F" id="stop28" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_211_370"
          x1="63.954498"
          y1="15.0431"
          x2="63.954498"
          y2="112.948"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.425135" stopColor="#71D89B" id="stop31" />
          <stop offset="1" stopColor="#12583F" id="stop33" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default GameGlassTextLogo
